<div class="wrapper">
    <div class="top-bar">
        <div class="left-section" *ngIf="batches">
            <h6>{{batches.department_name}}</h6>
            <p>{{batches.batch_name}} </p>
        </div>

        <div class="right-section">

            <div class="user-info" *ngIf="userDetail">
                <div>
                    <div class="name">{{ userDetail.first_name }} {{ userDetail.last_name }}</div>
                    <div class="email" [matTooltip]="userDetail.phone_email">
						 {{ userDetail.phone_email.length > 20
                         ? (userDetail.phone_email | slice : 0 : 20) + "..." : userDetail.phone_email}}
					</div>
                </div>
                <div class="avatar">{{ userDetail.first_name[0] }}{{ userDetail.last_name[0] }}</div>
            </div>
        </div>
    </div>
    <div class="back-btn">
        <button mat-button (click)="goBack()" aria-label="Back">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Batches</span>
        </button>
    </div>

	<ng-container *ngIf="isLoading;else pageContent">
  <div class="app-spinner">
	<mat-spinner></mat-spinner>
   </div>
	</ng-container>

	<ng-template #pageContent>
    <div class="stats-container" *ngIf="batches">
        <mat-card class="stat-card">
            <div class="stat-content">
                <div class="icon-text">
                    <div class="icon-box">
                        <mat-icon>groups</mat-icon>
                    </div>
                    <div class="text-box">
                        <p class="label">Total Students</p>
                        <h3 class="value">{{batches.total_students}}</h3>
                    </div>
                </div>
            </div>
        </mat-card>

        <mat-card class="stat-card">
            <div class="stat-content">
                <div class="icon-text">
                    <div class="icon-box">
                        <mat-icon>menu_book</mat-icon>
                    </div>
                    <div class="text-box">
                        <p class="label">Department</p>
                        <h2 class="value">{{batches.department_name}}</h2>
                    </div>
                </div>
            </div>
        </mat-card>

        <mat-card class="stat-card">
            <div class="stat-content">
                <div class="icon-text">
                    <div class="icon-box">
                        <mat-icon>assignment</mat-icon>
                    </div>
                    <div class="text-box">
                        <p class="label">Created On</p>
                        <h3 class="value">{{batches.created_at}}</h3>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
    </ng-template>

    <div class="students-card" *ngIf="batches">
        <div class="card-header">
            <h3>Students in this Batch</h3>
        </div>
		<ng-container *ngIf="batches.students.length > 0; else nouserData">
        <div class="table-container">
            <table class="students-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Department</th>
                        <th>Status</th>
                        <th>Joined On</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let student of batches.students">
                        <td>{{student.name}}</td>
                        <td>{{student.email}}</td>
                        <td><span class="dept">{{student.department}}</span></td>
                        <td><span class="status active"
                         [ngClass]="{
						 'active': student.status === studentStatusForBatch.Active,
                         'inactive': student.status !== studentStatusForBatch.Active }">
						  {{student.status}}</span></td>
                        <td>{{student.joined_on}}</td>
                        <td>
                            <button mat-icon-button color="warn" (click)="deleteUserById(student.user_id)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        </ng-container>
          <ng-template #nouserData>
      <mat-icon>info</mat-icon>
      <p>No students found in this batch.</p>
      </ng-template>
    </div>
</div>